export default __webpack_public_path__ + "static/media/paymentTutorial_mobile_bottom_Hk.4dc20bd8.webp";